import { defineStore } from "pinia";
import { FilterItemTypes } from "./types";
import { computed, ref } from 'vue';
export const useFilterStore = defineStore('filterStore', () => {
    const config = ref({});
    const values = ref({});
    const instance = ref(0);
    const active = computed(() => Object.keys(values.value).length > 0);
    const enabled = ref(true);
    const loaded = ref(false);
    const items = ref([]);
    const sort = ref({
        default: 'hot',
        type: 'hot',
        types: {},
    });
    function disable() {
        enabled.value = false;
    }
    function setLoaded(isLoaded = true) {
        loaded.value = isLoaded;
    }
    function setInitialState(state) {
        config.value = state.config;
        setValues(state.values);
    }
    function setValues(filterValues) {
        var _a, _b;
        for (const item of items.value) {
            let value = (_a = filterValues[item.name]) === null || _a === void 0 ? void 0 : _a.split('-');
            if ((_b = filterValues[item.name]) === null || _b === void 0 ? void 0 : _b.match(/^[\d-]+$/)) {
                value = value.map((v) => parseInt(v));
            }
            if (item.type === FilterItemTypes.List || item.type === FilterItemTypes.FilterableList) {
                item.active = !!(value === null || value === void 0 ? void 0 : value.length);
                for (const option of item.options) {
                    option.selected = !!(value === null || value === void 0 ? void 0 : value.includes(option.value));
                }
            }
            else if (item.type === FilterItemTypes.Flag) {
                item.active = value !== undefined;
            }
            else if (item.type === FilterItemTypes.Range) {
                if (value === null || value === void 0 ? void 0 : value.length) {
                    const [min, max] = value;
                    item.active = true;
                    item.value.min = parseInt(min);
                    item.value.max = parseInt(max);
                }
                else {
                    item.active = false;
                }
            }
        }
        const firstActiveItem = items.value.find(i => i.active);
        if (firstActiveItem) {
            firstActiveItem.expanded = true;
        }
    }
    function update(newItems) {
        items.value = newItems;
        if (!newItems.length) {
            disable();
        }
    }
    function updateValues() {
        let result = {};
        for (const item of items.value) {
            if (item.type === FilterItemTypes.List || item.type === FilterItemTypes.FilterableList) {
                const options = [];
                for (const option of item.options) {
                    if (option.selected) {
                        options.push(option.value);
                    }
                }
                if (options.length) {
                    result[item.name] = options.join('-');
                    item.active = true;
                }
                else {
                    item.active = false;
                }
            }
            if (item.type === FilterItemTypes.Flag) {
                if (item.active) {
                    result[item.name] = true;
                }
            }
            if (item.type === FilterItemTypes.Range) {
                if (item.value.min === item.available.min && item.value.max === item.available.max) {
                    item.active = false;
                    continue;
                }
                if (item.value.min === 0 && item.value.max === 0) {
                    item.active = false;
                    continue;
                }
                result[item.name] = `${item.value.min}-${item.value.max}`;
                item.active = true;
            }
        }
        values.value = result;
    }
    function setDefaultSort(defaultSort) {
        sort.value.default = defaultSort;
    }
    function setSortType(newSort) {
        sort.value.type = newSort;
        config.value.sort = newSort;
    }
    function setSortTypes(newSortTypes) {
        sort.value.types = newSortTypes;
    }
    return {
        // State
        config, values, instance,
        active, enabled, loaded,
        items, sort,
        // Methods
        disable, setLoaded, setInitialState,
        setValues, update, updateValues,
        setDefaultSort, setSortType, setSortTypes,
    };
});
